import { defineMeta } from '@/registry/types';

export const investigationLayoutMeta = defineMeta({
  name: 'InvestigationLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'Split investigation view with a canvas (graph/timeline) and a docked details + legend panel.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'SplitView',
  importPath: '@/templates/InvestigationLayout',
  requiredProps: ['canvas'],
  optionalProps: ['title', 'panel', 'showLegend'],
  supportedStates: ['default', 'with-panel'],
  designTokens: ['colors', 'spacing', 'attackPath'],
  accessibility: ['Provide accessible descriptions for graph content in the panel.'],
  usageExamples: ['<InvestigationLayout canvas={<Graph/>} panel={<Details/>} />'],
  antiPatterns: ['Do not hide the legend when showing attack-path colors.'],
  llmSafe: true,
  whenToUse: ['Attack-path / graph investigation screens'],
  whenNotToUse: ['Simple detail pages (use DetailsPageLayout)'],
});

export default investigationLayoutMeta;
